import fetebuddyGradientIcon from "../../../assets/images/fetebuddy-gradient-icon.svg";
import plusBlueIcon from "../../../assets/images/plus-blue-icon.svg";
import crossIcon from "../../../assets/images/cross-icon.svg";
import useAppState from "context/useAppState";
import Select from "react-select";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { isNewFete } from "utils/fete";
import { DEFAULT_FETEBUDDY_PROMPT_KEYS, DEFAULT_FETEBUDDY_INITIATE_MESSAGES, CHAT_SESSION, MESSAGE_TYPES } from "constants/llm";
import { getAnswerFromResponse } from "utils/llm";
import { getTimeForChatMessage, jsonToMarkdown } from "utils/function";
import { isEmpty } from "lodash";
import { PROMPT_DEFAULTS } from "utils/constant";
import allImgPaths from "assets/images";

const ChatboxHeader = (props: any) => {
	const { id } = useParams();
	const [dropDownOptions, setDropDownOptions] = useState<any[]>([]);

	const { setState: setEventDataState, openPlanningAnimation, showReviewSpace, callFromEmptyReviewSpace, eventFetchedData, eventTasks, unsavedChanges } = useAppState("eventData");
	const { setState: setCardWrapperState, updateCardSelectedState, selectedCardDetail } = useAppState("cardWrapper");
	const { getLLMResponse } = useAppState('chatBox');
	const { setState: setChatMessagesState, createSession, getUserChatSessions, getUserChatSessionMessages } = useAppState('chatMessages');
	const { draftEventTasks } = useAppState('newFeteChat')
	const { setState: setChatboxState, userChatSessions, currentSession, cardPrompt } = useAppState('chatBox');

	const userData = JSON.parse(localStorage.getItem('userData') as string)
	const currentTeam = JSON.parse(localStorage.getItem('selectedTeam') as string)

	const navigate = useNavigate();

	const getMetadataFilter = (isCard = false) => {
		let metadata_filter: any = {
			teamId: currentTeam?.currentTeamId,
			userId: userData?.id
		}
		if (isNewFete()) {
			return metadata_filter;
		}
		if (id) {
			metadata_filter['eventId'] = id
		}
		if (selectedCardDetail && isCard) {
			metadata_filter['cardId'] = selectedCardDetail?.id
		}
		return metadata_filter;
	}

	const getMetadataFilterForLLM = (isCard = false) => {
		let metadata_filter: any = {
			teamId: currentTeam?.currentTeamId,
		}
		if (isNewFete()) {
			return metadata_filter;
		}
		if (id) {
			metadata_filter['eventId'] = id
		}
		// if (selectedCardDetail && isCard) {
		//   metadata_filter['cardId'] = selectedCardDetail?.id
		// }
		return metadata_filter;
	}

	const getPromptKey = () => {
		if (isNewFete()) {
			return DEFAULT_FETEBUDDY_PROMPT_KEYS.START;
		}
		if (cardPrompt?.name) {
			return cardPrompt?.name;
		} else {
			return DEFAULT_FETEBUDDY_PROMPT_KEYS.CONTINUE;
		}
	}

	useEffect(() => {
		if (userChatSessions.length > 0) {
			const modifiedOptions = userChatSessions.map((session: any) => ({
				value: session._id,
				label: session.title,
			}));
			setDropDownOptions(modifiedOptions);
		}
	}, [userChatSessions])

	useEffect(() => {
		if (currentSession?._id && currentSession?.title) {
			setCurrentSelectedSession({ value: currentSession?._id, label: currentSession?.title, isSelected: true })
		}
	}, [currentSession])

	const getChatSessions = async () => {
		const userSessions = await getUserChatSessions({
			page: 0,
			perPage: 10,
			filter: getMetadataFilter(true),
		});
		return userSessions;
	}

	const getTasksInput = () => {
		if (selectedCardDetail) {
			return jsonToMarkdown(selectedCardDetail?.tasks)
		}
		if (id) {
			return jsonToMarkdown(eventTasks)
		}
		if (draftEventTasks && draftEventTasks?.length > 0) {
			return jsonToMarkdown(draftEventTasks)
		}
		return null;
	}

	const getLLMInputVariables = () => {
		const vars: any = {
			is_vendor: true,
			json_formats: PROMPT_DEFAULTS.JSON_FORMATS,
			notes: PROMPT_DEFAULTS.NOTES
		};
		if (eventFetchedData) {
			vars['event_details'] = jsonToMarkdown(eventFetchedData)
		}
		if (getTasksInput() !== '') {
			vars['task_list'] = getTasksInput()
		}
		return vars;
	}

	const handleNewChatClick = async () => {
		setEventDataState({ insavedChanges: false })
		if (isNewFete()) {
			setChatMessagesState({ messageHistory: [], showChatLoader: true })
			setChatboxState({ initNewFete: true })
			navigate('/fete/new')
		} else {
			const isClickedFromCard = cardPrompt || !isEmpty(cardPrompt) ? true : false;
			setChatMessagesState({ messageHistory: [], showChatLoader: isClickedFromCard ? false : true })
			const sessionRes = await createSession({
				title: CHAT_SESSION.DRAFT_TITLE,
				metadata: getMetadataFilter(true)
			});
			const userSessions = await getChatSessions();
			setChatboxState({ currentSession: sessionRes, userChatSessions: userSessions?.sessions || [] })
			if (!isClickedFromCard) {
				// New chat init only for Main FeteBuddy not for CARD level
				const llmRes = await getLLMResponse({
					input_variables: getLLMInputVariables(),
					userMessage: DEFAULT_FETEBUDDY_INITIATE_MESSAGES.CONTINUE,
					promptKey: getPromptKey(),
					session_id: sessionRes?._id,
					metadata_filter: getMetadataFilterForLLM()
				});
				setChatMessagesState({ messageHistory: [{ type: MESSAGE_TYPES.AI, content: getAnswerFromResponse(llmRes), createdAt: new Date().toISOString() }], showChatLoader: false })
			}
		}
	}

	const handleClose = (e: any) => {
		if (unsavedChanges) {
			const message = `You’ve unsaved changes in your ${selectedCardDetail.title || ''} fetebuddy. Are you sure you want to leave?`
			const confirmLeave = window.confirm(message);
			if (!confirmLeave) {
				e.preventDefault()
				return
			} else {
				setEventDataState({ unsavedChanges: false })
				handleOnCancelBtnClick()
			}
		} else {
			handleOnCancelBtnClick()
		}
	}

	const handleOnCancelBtnClick = () => {
		updateCardSelectedState("", { isSelected: false });
		setEventDataState({ showChatbox: false, openPlanningAnimation: false, showInsight: false, showReviewSpace: false });
		setCardWrapperState({
			chipsData: [],
			cardAnimation: false,
			openCardAnimation: false,
			selectedCardDetail: null
		})
		setChatboxState({ cardPrompt: null, currentSession: null, userChatSessions: [] })
		setChatMessagesState({ messageHistory: [], showChatLoader: false })
		if (isNewFete()) {
			navigate('/')
		}
	}

	let { activeState, setActiveState } = props;

	const [currentSelectedSession, setCurrentSelectedSession] = useState<any>(null);

	const customSelectStyle = {
		singleValue: (styles: any) => ({
			...styles,
			color: "#344054",
		}),
		valueContainer: (styles: any) => ({
			...styles,
			backgroundColor: "#fff",
			padding: "0px 0px 0px 5px",
			fontSize: "14px",
			cursor: "pointer",
		}),
		control: (styles: any) => ({
			...styles,
			backgroundColor: "#fff",
			padding: "4px 12px",
			borderRadius: "8px",
			cursor: "pointer",
			boxShadow: "0",
			"&:hover": {
				border: "1px solid #D0D5DD",
			},
		}),
		indicatorContainer: (styles: any) => ({
			...styles,
			padding: "0px 0px",
		}),
		indicatorSeparator: (styles: any) => ({ ...styles, display: "none" }),
		dropdownIndicator: (styles: any) => ({
			...styles,
			color: "#85888E",
			cursor: "pointer",
			"&:hover": { color: "#85888E" },
			paddingRight: "0px",
		}),
		menu: (styles: any) => ({
			...styles,
			left: "0",
			boxShadow:
				"0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.10)",
			backgroundColor: "#fff",
			borderRadius: "12px",
			margin: "0px",
			overflow: "hidden",
		}),
		menuList: (styles: any) => ({
			...styles,
			backgroundColor: "#fff",
			maxHeight: "192px",
			padding: "4px 4px",
		}),
		option: (styles: any, { isFocused, isSelected }: any) => ({
			...styles,
			cursor: "pointer",
			fontSize: "15px",
			fontWeight: "500",
			color: "#344054",
			padding: "6px 6px 6px 6px",
			borderRadius: "4px",
			marginBottom: "4px",
			//   backgroundColor: isFocused ? "#E8E6FE" : "#fff",
			backgroundColor: isSelected ? '#DAD8F7' : isFocused ? '#F0F2FF' : '#fff',
			"&:active": { backgroundColor: "#E8E6FE" },
			"&:hover": { backgroundColor: "#E8E6FE" },
		}),
		placeholder: (styles: any) => ({
			...styles,
			fontWeight: "500",
			fontSize: "16px",
		}),
	};

	const handleSessionChange = async (selectedSession: any) => {
		setChatboxState({ currentSession: { _id: selectedSession.value, title: selectedSession.label } })
		setCurrentSelectedSession(selectedSession);
		const chatSessionMessages = await getUserChatSessionMessages(selectedSession?.value)
		setChatMessagesState({ messageHistory: [...chatSessionMessages], showChatLoader: false })
	};

	const liRef = useRef(null)

	useEffect(() => {
		if (!showReviewSpace && callFromEmptyReviewSpace) {
			setActiveState('feteBuddy')
		}
		if (showReviewSpace && callFromEmptyReviewSpace) {
			handleFromOutside()
			setActiveState('reviewSpace')
		}
	}, [callFromEmptyReviewSpace]);

	const handleFromOutside = async () => {
		const sessionRes = await createSession({
			title: CHAT_SESSION.DRAFT_TITLE,
			metadata: getMetadataFilter(true)
		});
		const userSessions = await getChatSessions();
		setChatboxState({ currentSession: sessionRes, userChatSessions: userSessions?.sessions || [] })
	}

	// useEffect for managing unsaved changes warning when clicking on close icon
	useEffect(() => {
		const handleBeforeUnload = (e: any) => {
			if (unsavedChanges) {
				e.preventDefault();
				e.returnValue = ''; // Modern browsers require this to show the alert
				return '';
			}
		};

		window.addEventListener('beforeunload', handleBeforeUnload);

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload);
		};
	}, [unsavedChanges])

	return (
		<div className="flex items-center justify-between gap-x-4 bg-[#f9fafb]">
			<div>
				<ul className="flex items-center rounded-corner rounded-corner-chatbox border-b border-transparent -mb-px">
					{/* <li ref={liRef} onClick={(e) => { setActiveState("feteBuddy"); setEventDataState({ showReviewSpace: false }) }} className={`font-interSemiBold !pl-3 text-sm cursor-pointer ${activeState === "feteBuddy" ? "text-[#101828] remove-border-bottom pointer-none " : "text-[#667085]"}`}>
						<img className="w-6 h-6 mr-2" src={fetebuddyGradientIcon} alt="" />
						Fete Buddy
					</li>

					{!openPlanningAnimation && !isNewFete() && (
						<li onClick={(e) => {
							setActiveState("reviewSpace")
							setEventDataState({ showReviewSpace: true, isInsightCallApi: true })
						}}
							className={`font-interSemiBold text-sm cursor-pointer ${activeState === "reviewSpace" ? "text-[#101828] remove-border-bottom !z-10 pointer-none " : "text-[#667085]"}`}>Review Space</li>
					)} */}

					{!openPlanningAnimation && !isNewFete() && (
						<li onClick={(e) => {
							setActiveState("reviewSpace")
							setEventDataState({ showReviewSpace: true, isInsightCallApi: true })
						}}
							className={`font-interSemiBold text-sm cursor-pointer !pl-4 ${activeState === "reviewSpace" ? "text-[#101828] remove-border-bottom pointer-none !z-10" : "text-[#667085] hover:text-[#1E0AF5]"}`}>
							{/* Review Space */}
							{selectedCardDetail?.title}
						</li>
					)}

					<li ref={liRef} onClick={(e) => { setActiveState("feteBuddy"); setEventDataState({ showReviewSpace: false }) }} className={`font-interSemiBold text-sm cursor-pointer ${isNewFete() ? "!pl-[12px]" : "!pl-[42px]"} ${activeState === "feteBuddy" ? "text-[#101828] remove-border-bottom pointer-none !z-10 only-fetebuddy" : "text-[#667085] hover:text-[#1E0AF5] hover-fete-effect"}`}>
						<img className="w-6 h-6 mr-2" src={fetebuddyGradientIcon} alt="" />
						Fete Buddy
					</li>
				</ul>
			</div>

			<div className="flex items-center gap-x-4">
				{/* {!isNewFete() && (

					<div className="relative w-full chatbox-dropdowns past-chat">
						<Select
							value={currentSelectedSession}
							onChange={handleSessionChange}
							options={dropDownOptions}
							isSearchable={false}
							placeholder="Select past chat"
							className="multi-select-wrapper placeholder:text-[#344054] placeholder:text-base text-base text-[#344054]"
							classNamePrefix="select"
							styles={customSelectStyle}
						/>
					</div>
				)} */}
				<button
					className="flex items-center gap-x-2 border border-[#E8E6FE] rounded-lg py-2 px-3 bg-white shadow-customShadow4 new-chat-btn flex-shrink-0 hover:bg-[#F2F4F7]"
					onClick={() => handleNewChatClick()}
				>
					<img src={allImgPaths.plusIcon6} alt="" />
					<span className="text-sm text-[#344054] font-interSemiBold">New Chat</span>
				</button>
				<img
					className="cursor-pointer mr-4 hover:bg-[#e8e8e8] rounded w-5 p-0.5"
					src={crossIcon}
					alt=""
					onClick={handleClose}
				// onClick={handleOnCancelBtnClick}
				/>
			</div>
		</div>
	)
}

export default React.memo(ChatboxHeader);